module.exports = __webpack_public_path__ + "img/drive-dil-5.8cb71455.svg";